import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
// import "./utils/rem.js";
import "./assets/style/media.scss";
import "./assets/style/common.scss";

// 注册动画指令
import "animate.css";
import directives from "./utils/directives";

Vue.use(directives);
Vue.use(ElementUI);

// VConsole
import VConsole from "vconsole";
// 开发模式下开启VConsole
// if (process.env.NODE_ENV == "development") {
//   new VConsole();
// }

var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
 (function () {
       var hm = document.createElement("script");
       hm.src = "https://hm.baidu.com/hm.js?5854b1634c301f668fbe978e6f31ddea";
       var s = document.getElementsByTagName("script")[0];
       s.parentNode.insertBefore(hm, s);
  })();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
